export class SegmentModel {
  id: number;
  name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/segment/SegmentModel.ts